import styled, { keyframes, css } from 'styled-components';

// ── paleta (design system: teal + acentos) ─────────────────────────
const TEAL = 'var(--teal)';
const TEAL_TEXT = 'var(--teal-text, var(--teal))';
const TEAL_LIGHT = 'var(--teal-light)';
const TEAL_SOFT = 'var(--teal-soft)';
const GRAY_BG = 'var(--bg)';
const GRAY_LINE = 'var(--line)';
const GRAY_TEXT = 'var(--text-muted)';
const RED = 'var(--red, #dc2626)';
//const CORAL = 'var(--coral)';
const TEAL_GLOW = 'var(--teal-glow)';

const bp = { desktop: '1024px', tablet: '768px', mobile: '540px', small: '380px' };

const expand = keyframes`
  from { opacity: 0; transform: translateY(-6px); max-height: 0; }
  to   { opacity: 1; transform: translateY(0);    max-height: 9999px; }
`;
const fadeIn = keyframes`from { opacity: 0; } to { opacity: 1; }`;
const popIn = keyframes`
  0%   { opacity: 0; transform: translateY(8px) scale(0.98); }
  100% { opacity: 1; transform: translateY(0) scale(1); }
`;

/* ── Layout base ───────────────────────────────────────────────── */
export const Container = styled.div`
  width: 100%;
  max-width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  box-sizing: border-box;
  background:
    radial-gradient(1200px 400px at 50% -120px, var(--bg-glow) 0%, transparent 70%),
    ${GRAY_BG};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ContainerDivs = styled.div`
  width: 100%;
  max-width: 960px;
  min-width: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: 16px;
  gap: 14px;
  @media (max-width: ${bp.tablet}) { padding: 12px; }
  @media (max-width: ${bp.mobile}) { padding: 8px; gap: 10px; }
`;

/* ── Cabeçalho ─────────────────────────────────────────────────── */
export const Header = styled.div`
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  width: 100%;
  padding: 20px 24px;
  background: linear-gradient(135deg, ${TEAL} 0%, ${TEAL_LIGHT} 100%);
  color: #fff;
  border-radius: 18px;
  box-shadow: 0 8px 24px ${TEAL_GLOW};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  flex-wrap: wrap;

  &::before, &::after {
    content: '';
    position: absolute;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.06);
    pointer-events: none;
  }
  &::before { width: 180px; height: 180px; top: -70px; right: -40px; }
  &::after  { width: 120px; height: 120px; bottom: -60px; right: 90px; }

  @media (max-width: ${bp.mobile}) { padding: 18px; border-radius: 16px; }
`;

export const HeaderInfo = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 20px;
  font-weight: 800;
  letter-spacing: 0.2px;
  display: flex;
  align-items: center;
  gap: 10px;
  @media (max-width: ${bp.mobile}) { font-size: 18px; }
`;

export const Subtitle = styled.span`
  font-size: 13px;
  opacity: 0.85;
  font-weight: 500;
`;

export const CountPill = styled.div`
  position: relative;
  z-index: 1;
  background: rgba(255, 255, 255, 0.13);
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 12px;
  padding: 8px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 84px;

  strong { font-size: 19px; font-weight: 800; line-height: 1.1; }
  span { font-size: 10px; opacity: 0.85; text-transform: uppercase; letter-spacing: 0.6px; }
`;

/* ── Barra de busca / filtros ──────────────────────────────────── */
export const Search = styled.div`
  box-sizing: border-box;
  width: 100%;
  background: var(--surface);
  border: 1px solid ${GRAY_LINE};
  border-radius: 14px;
  box-shadow: 0 2px 10px rgba(0,0,0,.04);
  padding: 14px 16px;
  display: grid;
  grid-template-columns: 1fr 220px;
  gap: 12px;
  align-items: end;

  @media (max-width: ${bp.mobile}) {
    grid-template-columns: 1fr;
    padding: 12px;
    border-radius: 12px;
  }
`;

export const FormSearch = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;

  label {
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    color: ${GRAY_TEXT};
  }
`;

export const FormFilter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  label {
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    color: ${GRAY_TEXT};
  }
`;

export const SearchInputWrap = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  svg {
    position: absolute;
    left: 12px;
    color: ${GRAY_TEXT};
    pointer-events: none;
    font-size: 16px;
  }
`;

export const InputEmp = styled.input`
  width: 100%;
  box-sizing: border-box;
  border: 1px solid ${GRAY_LINE};
  background: var(--surface);
  border-radius: 9px;
  padding: 11px 12px 11px 36px;
  font-size: 14px;
  color: ${TEAL_TEXT};
  outline: none;
  min-height: 44px;
  transition: border-color .15s ease, box-shadow .15s ease;
  &::placeholder { color: #9aa7ad; }
  &:focus { border-color: ${TEAL_LIGHT}; box-shadow: 0 0 0 3px rgba(10,90,115,.12); }
  @media (max-width: ${bp.mobile}) { font-size: 16px; }
`;

export const Select = styled.select`
  width: 100%;
  box-sizing: border-box;
  border: 1px solid ${GRAY_LINE};
  background: var(--surface);
  border-radius: 9px;
  padding: 11px 12px;
  font-size: 14px;
  color: ${TEAL_TEXT};
  outline: none;
  cursor: pointer;
  min-height: 44px;
  transition: border-color .15s ease, box-shadow .15s ease;
  &:focus { border-color: ${TEAL_LIGHT}; box-shadow: 0 0 0 3px rgba(10,90,115,.12); }
  @media (max-width: ${bp.mobile}) { font-size: 16px; }
`;

export const Hint = styled.p`
  margin: 0;
  text-align: center;
  font-size: 13px;
  color: ${GRAY_TEXT};
  font-weight: 500;
`;

/* ── Grade de turmas ───────────────────────────────────────────── */
export const List = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Emp = styled.div`
  position: relative;
  background: var(--surface);
  border: 1px solid ${GRAY_LINE};
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(0,0,0,.04);
  padding: 18px 18px 18px 20px;
  cursor: pointer;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 72px;
  transition: transform .15s ease, box-shadow .15s ease, border-color .15s ease;
  animation: ${popIn} .25s ease backwards;

  /* faixa lateral teal */
  &::before {
    content: '';
    position: absolute;
    left: 0; top: 0; bottom: 0;
    width: 5px;
    background: ${TEAL};
    transition: width .15s ease;
  }

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 24px rgba(0,0,0,.10);
    border-color: ${TEAL_LIGHT};
  }
  &:hover::before { width: 8px; }
  &:active { transform: translateY(-1px); }
  &:focus-visible { outline: 2px solid ${TEAL_LIGHT}; outline-offset: 2px; }

  @media (max-width: ${bp.mobile}) { padding: 16px 16px 16px 18px; min-height: 64px; }
`;

export const Span = styled.span`
  color: ${TEAL_TEXT};
  font-size: 17px;
  font-weight: 700;
  overflow-wrap: anywhere;
  line-height: 1.25;
  @media (max-width: ${bp.mobile}) { font-size: 16px; }
`;

/* coluna esquerda do card: nome da turma + série logo abaixo */
export const EmpMain = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
  flex: 1;
`;

/* série — badge discreto abaixo do nome, indicando a que série a turma pertence */
export const SerieTag = styled.span`
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.2px;
  color: ${TEAL_LIGHT};
  background: ${TEAL_SOFT};
  border: 1px solid rgba(10, 90, 115, 0.14);
  padding: 3px 9px 3px 7px;
  border-radius: 7px;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;

  /* marcador de "nível" à esquerda do texto */
  &::before {
    content: '';
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: ${TEAL_LIGHT};
    flex-shrink: 0;
  }

  @media (max-width: ${bp.mobile}) { font-size: 11.5px; }
`;

export const ShiftTag = styled.span`
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 999px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  white-space: nowrap;
  ${({ $shift }) => {
    switch ($shift) {
      case 'MATUTINO':   return css`background:#fef3d6; color:#b07d11;`;
      case 'VESPERTINO': return css`background:rgba(59,130,246,0.18); color:var(--blue, #3b82f6);`;
      case 'NOTURNO':    return css`background:#e7e3fb; color:#5b4ad0;`;
      default:           return css`background:${TEAL_SOFT}; color:${TEAL_TEXT};`;
    }
  }}
`;

export const GoArrow = styled.span`
  flex-shrink: 0;
  color: ${TEAL_LIGHT};
  font-size: 18px;
  display: inline-flex;
  align-items: center;
`;

/* ── Estados vazio / erro ──────────────────────────────────────── */
export const EmptyState = styled.div`
  box-sizing: border-box;
  width: 100%;
  background: var(--surface);
  border: 1px dashed ${GRAY_LINE};
  border-radius: 14px;
  padding: 40px 24px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;

  .icon { font-size: 40px; opacity: 0.6; }
  h3 { margin: 0; font-size: 16px; color: ${TEAL_TEXT}; }
  p { margin: 0; color: ${GRAY_TEXT}; font-size: 14px; }
`;

export const RetryButton = styled.button`
  background: ${TEAL};
  color: #fff;
  border: none;
  padding: 10px 24px;
  border-radius: 9px;
  cursor: pointer;
  font-weight: 700;
  font-size: 14px;
  min-height: 42px;
  transition: filter .12s ease, transform .12s ease;
  &:hover { filter: brightness(1.1); }
  &:active { transform: translateY(1px); }
`;

/* ── Skeleton ──────────────────────────────────────────────────── */
const shimmer = keyframes`
  0%   { background-position: -400px 0; }
  100% { background-position: 400px 0; }
`;
export const SkeletonCard = styled.div`
  height: 72px;
  border-radius: 14px;
  border: 1px solid ${GRAY_LINE};
  background: linear-gradient(90deg, var(--skel-a) 0%, var(--skel-b) 50%, var(--skel-a) 100%);
  background-size: 800px 100%;
  animation: ${shimmer} 1.3s linear infinite;
`;

/* ── Modal de bloqueio (diário indisponível) ───────────────────── */
export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  backdrop-filter: blur(6px);
  background-color: rgba(0, 30, 38, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 16px;
  animation: ${fadeIn} .15s ease;
  @media (max-width: ${bp.mobile}) { padding: 0; align-items: flex-end; }
`;

export const BlockModal = styled.div`
  background: var(--surface);
  padding: 30px;
  border-radius: 16px;
  text-align: center;
  max-width: 420px;
  width: 100%;
  box-shadow: 0 18px 50px rgba(0,0,0,0.25);
  animation: ${expand} .2s ease;

  h3 {
    margin: 0 0 14px;
    color: ${RED};
    font-size: 18px;
    font-weight: 700;
  }
  p {
    font-size: 14px;
    line-height: 1.55;
    color: ${GRAY_TEXT};
    margin: 0;
  }

  @media (max-width: ${bp.mobile}) {
    border-radius: 18px 18px 0 0;
    max-width: 100%;
    padding: 24px 18px;
  }
`;

export const LogoutButton = styled.button`
  margin-top: 22px;
  padding: 11px 24px;
  border-radius: 9px;
  border: none;
  background: ${RED};
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  min-height: 44px;
  transition: filter .12s ease, transform .12s ease;
  &:hover { filter: brightness(1.05); }
  &:active { transform: translateY(1px); }
`;

/* mantidos por compat (não usados diretamente) */
export const AreaEmp = styled.div`display: flex; align-items: center;`;